import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import AppHeader from '../../Layout/AppHeader';

export default function AppMain({ children }) {
    return (
        <Fragment>
            <div className="app-container app-theme-white fixed-header">
                <AppHeader />
                <div className="app-main">
                    <div className="app-main__outer">
                        <div className="app-main__inner">{children}</div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

AppMain.propTypes = {
    children: PropTypes.element.isRequired,
};
